import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {axiosBaseQuery} from "utils/http"
import {Branch} from "../../types/Branch"
import {PAGINATION_LIMITS} from "../../constants/constants"

interface ResponseBranches {
    status: "status" | "error"
    data: {
        content: Branch[]
        page_number: number
        page_size: number
        total_elements: number
    }
}

interface ResponseSyncBranches {
    status: "status" | "error"
}

interface BranchesRequestParams {
    page: number
    size: number
}

interface ArgsEditBranch {
    id: string
    data: {
        enabled?: boolean
    }
}

interface ResponseEditBranch {
    status: "status" | "error"
}

const endpoints = {
    Branches: "/branches",
    BranchesList: "/branches/list",
    BranchesSync: "/branches/sync",
    FoodCourt: "/food-court",
    Inactivation: "/inactivation",
    Activation: "/activation"
}

export const branchApi = createApi({
    reducerPath: "branchApi",
    baseQuery: axiosBaseQuery(),
    tagTypes: ["branch"],
    endpoints: build => ({
        getBranches: build.query<ResponseBranches, BranchesRequestParams | void>({
            query: args => {
                const {page = 1, size = PAGINATION_LIMITS.FIVE_HUNDRED} = args || {}
                return {
                    url: endpoints.BranchesList,
                    method: "POST",
                    body: {page, size}
                }
            },
            providesTags: ["branch"]
        }),
        syncBranches: build.mutation<ResponseSyncBranches, void>({
            query: () => ({
                url: endpoints.BranchesSync,
                method: "POST"
            }),
            invalidatesTags: ["branch"]
        }),
        editFoodCourtType: build.mutation<ResponseEditBranch, ArgsEditBranch>({
            query: ({id, data}) => ({
                url: `${endpoints.Branches}/${id}${endpoints.FoodCourt}`,
                method: "PATCH",
                body: data
            }),
            invalidatesTags: ["branch"]
        }),
        updateBranchStatus: build.mutation<void, ArgsEditBranch>({
            query: params => {
                const baseEndpoint = `${endpoints.Branches}/${params?.id}`
                const endpoint = params?.data?.enabled ? endpoints.Inactivation : endpoints.Activation

                return {
                    url: `${baseEndpoint}${endpoint}`,
                    method: "PATCH"
                }
            },
            invalidatesTags: ["branch"]
        })
    })
})

export const {
    useEditFoodCourtTypeMutation,
    useSyncBranchesMutation,
    useGetBranchesQuery,
    useUpdateBranchStatusMutation
} = branchApi
